import client from "../client";
import { OrganizationType, PaginationRequest } from "src/types/commonTypes";

export interface ReportsRequest extends PaginationRequest {
  filter?: {
    report_filter?: {
      report_date?: {
        min?: string;
        max?: string;
      };
    };
  };
}

export const getReport = (data: ReportsRequest) => {
  return client({
    query: `query SearchReport($input: SearchInput) {
        search_report(input: $input) {
            total_pages                
            total_size                
            reports {                    
                report_id             
                report_type  
                status    
                report_date                        
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};

export interface ReportsContentRequest extends PaginationRequest {
  filter: {
    report_content_filter: {
      report_ids?: string[];
      object_ids?: string[];
      buckets?: string[];
      stages?: string[];
      organisation_types?: OrganizationType[];
      report_date?: {
        min?: string;
        max?: string;
      };
    };
  };
}

export const getReportContent = (data: ReportsContentRequest) => {
  return client({
    query: `query SearchReportContent($input: SearchInput) {
        search_report_content(input: $input) {
            total_pages                
            total_size                
            report_content_list {                    
                report_id
                report_date             
                report_content_id             
                report_type  
                object_id
                object_type
                data                          
            }    
        }
    }`,
    variables: {
      input: data
    }
  });
};
